import { CommonModule } from '@angular/common';
import { Component, effect, input } from '@angular/core';
import { Toast, ToastService } from '~/app/services/toast.service';
import { SnackbarComponent } from '../snackbar/snackbar.component';

@Component({
  selector: 'gplus-toast-container',
  imports: [CommonModule, SnackbarComponent],
  templateUrl: './toast-container.component.html',
  styleUrl: './toast-container.component.scss'
})
export class ToastContainerComponent {
  private timeoutId;
  public toast = input<Toast>(null);

  public iconsMap = { error: 'error', warning: 'warning', info: 'info', success: 'check_circle' };

  constructor(private readonly toastService: ToastService) {
    effect(() => {
      if (this.toast()?.delay) {
        this.timeout();
      }
    });
  }

  private timeout() {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }

    this.timeoutId = setTimeout(() => {
      this.close();
    }, this.toast()?.delay);
  }

  public close(): void {
    if (this.toast()?.type) {
      this.toastService.close(this.toast()?.type);
    }
  }
}
